
import {throwError as observableThrowError, Observable, Subject } from 'rxjs';
import { Injectable } from '@angular/core';
import {HttpClient, HttpHeaders, HttpResponse, HttpRequest, HttpParams} from '@angular/common/http';
import { apiConstant } from '../../app/app-constant';
import { Router } from "@angular/router";
import { routes } from '../../app/routes.constant';
import { environment } from '../../environments/environment';
import 'rxjs/Rx';

interface RequestOptions { 
  headers?: HttpHeaders; 
  reportProgress?: boolean; 
  params?: HttpParams; 
  responseType?: "arraybuffer" | "blob" | "text" | "json"; 
  withCredentials?: boolean; 
};

@Injectable()
export class HttpWrapperService {

  public loaderFlag = new Subject<string>();

  constructor(private http: HttpClient, private router: Router) { }

  get(url: string, apiHeader?: any, isBlob?: boolean, toggleLoader?: boolean, isText?: boolean) {
    return this.request(url, 'GET', {}, apiHeader, isBlob, toggleLoader, isText);
  }

  post(url: string, body: any = {}, apiHeader?: any, isBlob?: boolean, toggleLoader?: boolean) {
    return this.request(url, 'POST', body, apiHeader, isBlob, toggleLoader);
  }

  put(url: string, body: any = {}, apiHeader?: any, isBlob?: boolean, toggleLoader?: boolean) {
    return this.request(url, 'PUT', body, apiHeader, isBlob, toggleLoader);
  }

  patch(url: string, body: any = {}, apiHeader?: any, isBlob?: boolean, toggleLoader?: boolean) {
    return this.request(url, 'PATCH', body, apiHeader, isBlob, toggleLoader);
  }

  delete(url: string, body: any = {}, apiHeader?: any, isBlob?: boolean, toggleLoader?: boolean) {
    return this.request(url, 'DELETE', body, apiHeader, isBlob, toggleLoader);
  }

  private request(url: string, method: string, body?: any, apiHeader?: any, isBlob = false, toggleLoader = true, isText = false): any {
    if(toggleLoader) {
      this.loaderFlag.next('Y');
    }
    //console.log(body);
    let that = this;
    let headerData: any;
    // if(url.indexOf(apiConstant.DOC_UPLOAD) > -1 || url.indexOf(apiConstant.SHARE_TXN) > -1) {
    //   headerData = {
    //     'Authorization': localStorage.getItem('token')
    //   };
    // } else {
    //   headerData = {
    //     // 'Content-Type': 'application/json',
    //     'Authorization': localStorage.getItem('token')
    //   };
    // }
    headerData = {
      'Authorization': localStorage.getItem('token')
    };
    
    //let headers = new Headers(Object.assign(headerData, apiHeader));
    const headers = new HttpHeaders(Object.assign(headerData, apiHeader));

    // const options = new BaseRequestOptions();
    // options.url = url;
    // options.method = method;
    // options.body = body;
    // options.headers = headers;
    // if(isBlob) {
    //   options.responseType = ResponseContentType.Blob;
    // }
    const options: any = {
      headers: headers,
      responseType: (isBlob ? "blob" : (isText ? "text" : null))
    };
    //const request = new Request(options);
    let req;
    switch(method) {
      case 'GET': req = this.http.get(url, options);break;
      case 'POST': req = this.http.post(url, body, options);break;
      case 'PUT': req = this.http.put(url, body, options);break;
      case 'PATCH': req = this.http.patch(url, body, options);break;
      case 'DELETE': req = this.http.delete(url, options);break;
    }
    return req.map(function(res: any) {
        return that.onSuccessHandler(res, toggleLoader);
      })
      .catch((error: any) => that.onErrorHandler(error));
  }

  private onSuccessHandler(res: any, toggleLoader) {
    if(toggleLoader) {
      this.loaderFlag.next('N');
    }
    return res;
  }

  private onErrorHandler(error: any) {
    this.loaderFlag.next('N');
    //const errors = error.json();
    /* if(error.status == 406 && Array.isArray(errors) && errors.indexOf("User is not logged in.") !== -1) {
    } else if (error.status == 401 && Array.isArray(errors) && errors.indexOf("CSRF validation failed") !== -1) {
      // TODO: should logout after getting token
    } */
    //console.log(error);

    /* if(error._body == "\"JWT Token expired\"") { */
    if(error.status == 401) {
      localStorage.removeItem("loggedIn");
      localStorage.removeItem('stopFirstLoader');
      //this.loggedIn = null;//ToRemove
      //this.router.navigate([routes.DIGITAL_HUB]);

      let hsbcNetUrl = localStorage.getItem('hsbcneturl') ? localStorage.getItem('hsbcneturl') : environment.hsbcNetUrl;
      window.location.href = hsbcNetUrl;
    }
    
    return observableThrowError(error);
  }

}